export default __webpack_public_path__ + "images/20846c9392724e8db25a4673d7077377-metric_anatomy.png";